module.exports = "/assets/data/2b646601ced0eef703ada324f47d0b69-CF15.data.json";